import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { Subject } from "rxjs";

import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';

import { Device } from '../device.model';
import { Controller, IP, Vendor } from '../controller.model';
import { DeviceService } from '../device.service';

import { Organization } from '../../organization/organization.model';
import { OrganizationService } from '../../organization/organization.service';

import { Location } from '../../locations/location.model';
import { LocationService } from '../../locations/location.service';

import { LocationOrgFilterPipe } from '../../shared/location-org-filter.pipe';

import { NotificationService } from '../../shared/notification/notification.service';

@Component({
  selector: 'app-device-detail',
  templateUrl: './device-detail.component.html',
  styleUrls: ['./device-detail.component.scss']
})
export class DeviceDetailComponent implements OnInit {

  public deviceID: number;
  public device: Device;
  public deviceLoaded: boolean = false;
  public activeConnection: IP | null = null;
  public activeControllers: Controller[] = [];

  public glEditStatus: boolean = false;

  //TODO: replace with call to DB
  public vendors: Vendor[] = [
    {
       "id":1,
       "name":"Eclypse",
       "has_remote_desktop":true,
       "has_reboot":true,
       "method":"tun",
       "default_path":"http:\/\/\/localhost\/SensorView\/Overview.aspx",
       "default_path_text":"SensorView",
       "links":[
         {vendor_id: 1, path: "/eclypse/envysion/index.html", text: "Envysion"},
         {vendor_id: 1, path: "/eclypse/envysion/viewer.html?proj=nLightExplorer", text: "nLight Explorer"},
         {vendor_id: 1, path: "/eclypse/envysion/viewer.html?proj=SiteView_Energy", text: "SiteView Energy"},
         {vendor_id: 1, path: "/eclypse/envysion/viewer.html?proj=SpaceUtilization", text: "Space Utilization"},
       ]
    },
    {
       "id":2,
       "name":"Mosaic",
       "has_remote_desktop":false,
       "has_reboot":false,
       "method":"tun",
       "default_path":"C:\/Users\/User\/Documents\/ETC\/Paradigm\/",
       "default_path_text":"Paradigm",
       "links":[]
    },
    {
       "id":3,
       "name":"Crestron",
       "has_remote_desktop":false,
       "has_reboot":false,
       "method":"tun",
       "default_path":"C:UsersUserDownloads",
       "default_path_text":"Crestron",
       "links":[]
    },
    {
       "id":4,
       "name":"Hubbell",
       "has_remote_desktop":false,
       "has_reboot":true,
       "method":"tun",
       "default_path":"",
       "default_path_text":"Hubbell",
       "links":[]
    }
  ]

  public guacUrl: string;
  public guacLoading: boolean = false;

  constructor(
    public router: Router,
    public activatedRoute: ActivatedRoute,
    public deviceService: DeviceService,
    public organizationService: OrganizationService,
    public locationService: LocationService,
    public notificationService: NotificationService,
		public modalService: NgbModal
  ) { }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe((params) => {
      if (params.device_id) {
        this.deviceID = params.device_id;
        this.deviceService.devicesSubject.subscribe((res) => {
          if (!this.device) this.device = this.deviceService.device(this.deviceID);
          if (this.device && !this.deviceLoaded) {
            this.activeControllers = this.device.connections.filter((c) => c.ips.length);
            if (this.device.hologram_device_id) {
              this.deviceService.getDeviceCellular(this.device.hologram_device_id)
                .subscribe((data) => {
                  if (data.links && data.links.cellular.length > 0) {
                    let link = data.links.cellular[0];
                    this.device.cell_state = this.convertDeviceState(link.state);
                    this.device.sim = link.sim;

                    this.device.cell_usage = this.formatCellUsageData(link.cur_billing_data_used);
                    this.device.cell_limit = this.formatCellUsageData(link.plan.data);
                  }
                });
            }
            this.deviceLoaded = true;
          }
        })
      } else {
        this.router.navigate(['../devices']);
      }
    })
  }

  formatCellUsageData(val) {
    let retVal: any = { value: null, unit: null };
    retVal.value = val / 1000;
    retVal.unit = 'KB';
    if (retVal.value > 1000) {
      retVal.value /= 1000;
      retVal.unit = 'MB';
    }
    retVal.value = Math.round(retVal.value * 10) / 10;
    return retVal
  }

  convertDeviceState(state) {
    if (state.toLowerCase().includes('pause')){
      state = 'paused';
    }

    if (state.toLowerCase().includes('live')){
      state = 'live';
    }
    return state;
  }

  changeDeviceState() {
    let newState = this.device.cell_state.toLowerCase() === 'live' ? 'paused' : 'live';
    let deviceSub: any;
    if (newState === 'live') {
      deviceSub = this.deviceService.unpauseCellular([this.device]);
    } else {
      deviceSub = this.deviceService.pauseCellular([this.device]);
    }

    deviceSub.subscribe((data) => {
      this.device.cell_state = this.convertDeviceState(newState);
    });
  }

  editGL() {
    this.glEditStatus = true;
  }

  addController(vendorID) {
    let deviceVendor = this.vendors[vendorID - 1];
    let controller = this.device.connections.find((c) => c.vendor.id === vendorID);
    if (!controller) {
      this.device.connections.push(new Controller({
        device_id: this.deviceID,
        vendor_id: vendorID,
        vendor: new Vendor(deviceVendor),
        path: this.vendors[vendorID - 1].default_path,
        ips: []
      }));
      controller = this.device.connections[this.device.connections.length - 1];
    }

    this.addIP(controller);
  }

  addIP(connection) {
    let ip = new IP({
      connection_id: connection.id,
      ip: '',
      label: '',
      hostname: '',
      ip_index: connection.ips.length,
      editing: true
    });
    connection.ip = ip;
    this.deviceService.addIP(connection)
      .subscribe((result) => {
        ip.id = result.ip.id;
        connection.ips.push(ip);
        this.editIP(ip);
        this.notificationService.success('New Controller Added!', 3000)
      });
  }

  editIP(ip: IP) {
    ip.editing = true;
    ip.relay = ip.id == this.device.relay_controller_id;
  }

  saveIP(controller: Controller, ip: IP) {
    controller.ip = ip;
    this.deviceService.saveIP(controller)
      .subscribe((result) => {
        ip.editing = false;
        this.notificationService.success(`${controller.vendor.name} saved!`, 3000)
      });

    // Save relay controller ID
    if (!this.device.relay_controller_id || this.device.relay_controller_id == ip.id || ip.relay) {
      let id_value = ip.relay ? ip.id : null;
      this.deviceService.updateDeviceRelay(this.device.id, id_value)
        .subscribe((res) => {
          this.device.relay_controller_id = id_value;
          this.deviceService.update();
        });
    }
  }

  deleteIP(ip: IP) {
    if (ip.id) {
      this.deviceService.deleteIP(ip.id, this.device.id)
        .subscribe((result) => {
          let connection = this.deviceService.controller(this.device.id, ip.connection_id);
          connection.ips.splice(ip.ip_index, 1);
          this.deviceService.update();
          this.notificationService.success('Controller deleted.', 3000)
        });
    }
  }

  authenticateGuac(device) {
    this.guacLoading = true;
    let guac_sub = this.deviceService.getGuacToken(device.connections[0].id).subscribe((ret) => {
      if (ret) {
        if (ret.url) {
          this.guacUrl = ret.url;
        } else {
          this.notificationService.error('Could not connect to PC!', 3000)
        }
        this.guacLoading = false;
      }
    })
  }

  saveDevice() {
    this.deviceService.saveDevice(this.device)
      .subscribe((res) => {
        this.device.editing = false;
      });
  }

	openSerialTerminalModal(content) {
    this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title', size: 'lg', backdrop: 'static'}).result.then((result) => {
      if (result === 'save') {
      }
    }, (reason) => {
      console.log(reason);
    });
  }

}
